export default __webpack_public_path__ + "static/media/Group 8151.5b2827f5.png";